import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { renderField } from "../components";
import { validateRequired } from "../validation";

const borderStyle = { border: "1px solid #000", padding: 5 };
const translationStyle = { lineHeight: 2 };

const DropDownSelect = ({ input, items }) => {
  const renderSelectOptions = item => (
    <option key={item.label} value={item.value}>
      {item.label}
    </option>
  );

  return (
    <div>
      <select {...input} style={{ height: "30px" }}>
        {items.map(renderSelectOptions)}
      </select>
    </div>
  );
};

DropDownSelect.propTypes = {
  items: PropTypes.array,
  input: PropTypes.object,
  label: PropTypes.string,
};

const WeightHeight = () => (
  <Fragment>
    <table style={{ borderCollapse: "collapse", width: "100%" }}>
      <tbody>
        <tr>
          <td style={borderStyle} colSpan={2}>
            <b>Please answer the following questions carefully</b>
            <div style={translationStyle}>請清楚回答下列問題</div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }}>
            Height
            <br />
            <div style={translationStyle}>身高</div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }}>
            Weight
            <br />
            <div style={translationStyle}>體重</div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }} colSpan={2}>
            Any weight change during <br /> the past 12 months ? <br />
            <div style={translationStyle}>過去12個月之體重改變?</div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }} colSpan={2}>
            Reason for Change
            <br />
            <div style={translationStyle}>改變原因</div>
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={2}>
            Insured Employee
            <div style={{ marginTop: "10px" }}>被保之僱員</div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Field
                id="Height"
                name="Height"
                type="number"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%", height: "30px" }}
              />
              <Field
                id="HeightUnit"
                name="HeightUnit"
                component={DropDownSelect}
                items={[
                  { label: "m/米", value: "m/米" },
                  { label: "ft,in/呎,吋", value: "ft,in/呎,吋" },
                ]}
                style={{ width: "100%" }}
              ></Field>
            </div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Field
                id="Weight"
                name="Weight"
                type="number"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%", height: "30px" }}
              />
              <Field
                id="WeightUnit"
                name="WeightUnit"
                component={DropDownSelect}
                items={[
                  { label: "kg/公斤", value: "kg/公斤" },
                  { label: "lbs/磅", value: "lbs/磅" },
                ]}
                style={{ width: "100%" }}
              ></Field>
            </div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }} colSpan={2}>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Field
                id="WeightChangeOperator"
                name="WeightChangeOperator"
                component={DropDownSelect}
                items={[
                  { label: "+", value: "+" },
                  { label: "-", value: "-" },
                ]}
                style={{ width: "100%" }}
              ></Field>
              <Field
                id="WeightChange"
                name="WeightChange"
                type="number"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%", height: "30px" }}
              />
              <Field
                id="WeightChangeUnit"
                name="WeightChangeUnit"
                component={DropDownSelect}
                items={[
                  { label: "kg/公斤", value: "kg/公斤" },
                  { label: "lbs/磅", value: "lbs/磅" },
                ]}
                style={{ width: "100%" }}
              ></Field>
            </div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }} colSpan={2}>
            <Field
              id="WeightChangeReason"
              name="WeightChangeReason"
              type="text"
              component={renderField}
              style={{ width: "100%" }}
            />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
  </Fragment>
);

export default WeightHeight;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/AXAHD202404/WeightHeight.js